import { render, staticRenderFns } from "./VendorCards.vue?vue&type=template&id=cc0161b8"
import script from "./VendorCards.vue?vue&type=script&lang=js"
export * from "./VendorCards.vue?vue&type=script&lang=js"
import style0 from "./VendorCards.vue?vue&type=style&index=0&id=cc0161b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports